/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Welcome_BackInputs */

const th_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ยินดีต้อนรับกลับมา ${i?.name}`)
};

const en_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welcome back, ${i?.name}.`)
};

const ja_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`おかえりなさい、${i?.name}さん。`)
};

const zh_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`欢迎回来，${i?.name}。`)
};

const es_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hola de nuevo, ${i?.name}.`)
};

const pt_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Que bom te ver, ${i?.name}.`)
};

const id_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selamat datang kembali, ${i?.name}.`)
};

const fr_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bon retour, ${i?.name}.`)
};

const tl_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Maligayang pagbabalik, ${i?.name}.`)
};

const vi_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chào bạn trở lại, ${i?.name}.`)
};

const ko_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`다시 오셨군요, ${i?.name}님.`)
};

const de_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Willkommen zurück, ${i?.name}.`)
};

const ru_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`С возвращением, ${i?.name}.`)
};

const tr_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tekrar hoş geldiniz, ${i?.name}.`)
};

const it_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bentornato, ${i?.name}.`)
};

const pl_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Witaj ponownie, ${i?.name}.`)
};

const uk_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`З поверненням, ${i?.name}.`)
};

const hi_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`फिर से स्वागत है, ${i?.name}।`)
};

const ar_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`أهلًا بعودتك يا ${i?.name}.`)
};

const ms_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selamat kembali, ${i?.name}.`)
};

const bn_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`আবার স্বাগতম, ${i?.name}।`)
};

const zh_tw2_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`歡迎回來，${i?.name}。`)
};

const zh_hk2_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`歡迎回來，${i?.name}。`)
};

const ur_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`واپسی پر خوش آمدید، ${i?.name}۔`)
};

const fa_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`خوش آمدید، ${i?.name}.`)
};

const sw_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Karibu tena, ${i?.name}.`)
};

const nl_welcome_back = /** @type {(inputs: Welcome_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welkom terug, ${i?.name}.`)
};

/**
* | output |
* | --- |
* | "Welcome back, {name}." |
*
* @param {Welcome_BackInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const welcome_back = /** @type {((inputs: Welcome_BackInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_BackInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_welcome_back(inputs)
	if (locale === "ja") return ja_welcome_back(inputs)
	if (locale === "zh") return zh_welcome_back(inputs)
	if (locale === "es") return es_welcome_back(inputs)
	if (locale === "pt") return pt_welcome_back(inputs)
	if (locale === "id") return id_welcome_back(inputs)
	if (locale === "fr") return fr_welcome_back(inputs)
	if (locale === "tl") return tl_welcome_back(inputs)
	if (locale === "vi") return vi_welcome_back(inputs)
	if (locale === "ko") return ko_welcome_back(inputs)
	if (locale === "de") return de_welcome_back(inputs)
	if (locale === "ru") return ru_welcome_back(inputs)
	if (locale === "tr") return tr_welcome_back(inputs)
	if (locale === "it") return it_welcome_back(inputs)
	if (locale === "pl") return pl_welcome_back(inputs)
	if (locale === "uk") return uk_welcome_back(inputs)
	if (locale === "hi") return hi_welcome_back(inputs)
	if (locale === "ar") return ar_welcome_back(inputs)
	if (locale === "ms") return ms_welcome_back(inputs)
	if (locale === "bn") return bn_welcome_back(inputs)
	if (locale === "zh-TW") return zh_tw2_welcome_back(inputs)
	if (locale === "zh-HK") return zh_hk2_welcome_back(inputs)
	if (locale === "ur") return ur_welcome_back(inputs)
	if (locale === "fa") return fa_welcome_back(inputs)
	if (locale === "sw") return sw_welcome_back(inputs)
	if (locale === "nl") return nl_welcome_back(inputs)
	return en_welcome_back(inputs)
});